export const icons = {
  get (name, css_classes) {
    let obj = this.icons[name]
    if (obj) {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + obj.viewbox + '" class="svg ' + css_classes + '">' + obj.path + '</svg>'
    } else {
      return '<!-- !load icon ' + name + ' -->'
    }
  },
  icons: {
    dot: {
      viewbox: '0 0 512 512', 
      path: '<path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"/></svg>'
    },
    next: {
      viewbox: '0 0 320 512',
      path: '<path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"/>'
    },
    prev: {
      viewbox: '0 0 320 512',
      path: '<path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/>'
    },
    pause: {
      viewbox: '0 0 512 512', 
      path: '<path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"/>'
    },
    play: {
      viewbox: '0 0 512 512',
      path:'<path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z"/>'
    }
  }
}
